"use client";

/*

  return width for video preview dimensions
  We calculate the video preview dimensions based on the parent container & vertical thumbs slider height.

*/

import { useLayoutEffect, useCallback, useState } from "react";
import { debounce } from "../delay";
import type { TVideoPreviewDims } from "@hsr/types";

const initialDims: TVideoPreviewDims = {
  videoWidth: 0,
  videoHeight: 0
};

export const useVideoWrapper = (): TVideoPreviewDims => {
  const [dims, setDims] = useState<TVideoPreviewDims>(initialDims);

  const handleResize = useCallback(() => {
    const sliderEl: HTMLElement | null = document.getElementById("thumbsDiv");
    const parentEl: HTMLElement | null = document.getElementById(
      "productMediaPreview"
    );

    const sliderWidth = sliderEl?.clientWidth ?? 0;
    const sliderHeight = sliderEl?.clientHeight ?? 0;
    const parentWidth = parentEl?.clientWidth ?? 0;
    const gap = 32;
    const isVertical = sliderHeight > sliderWidth;

    let videoHeight = 0;
    let videoWidth = 0;

    if (isVertical) {
      const maxVideoWidth = parentWidth - sliderWidth - gap;

      videoHeight = sliderHeight;
      videoWidth = sliderHeight * 1.33;

      // scale down the video width to fit the parent container
      if (videoWidth > maxVideoWidth) {
        videoWidth = maxVideoWidth;
        videoHeight = maxVideoWidth / 1.33;
      }
    }
    if (!isVertical) {
      videoWidth = parentWidth;
      videoHeight = parentWidth / 1.33;
    }

    setDims({
      videoWidth,
      videoHeight
    });
  }, []);

  useLayoutEffect(() => {
    handleResize();

    // Debounce to avoid the function fire multiple times
    const handleResizeDebounced = debounce(handleResize, 250);
    window.addEventListener("resize", handleResizeDebounced);

    return () => {
      window.removeEventListener("resize", handleResizeDebounced);
      setDims(initialDims);
    };
  }, [handleResize]);

  return dims;
};
